module.exports = __webpack_public_path__ + "static/img/chalkboard.4230569.png";